<template>
  <VLayout class="flex column" style="height: 100%">
    <VToolbar flat style="border-bottom: solid 1px #dddddd">
      <VToolbarTitle>
        <div>
          <span>Priponke za ločit ({{ pagination_splitting.count }})</span>
        </div>
      </VToolbarTitle>
    </VToolbar>
    <VList
      v-if="attachmentList.length > 0"
      class="pb-0 pt-0"
      style="height: calc(100% - 100px); overflow-y: auto; flex: 1 0 1"
      three-line
    >
      <VListTile
        v-for="attachment in attachmentList"
        :key="attachment.url"
        @click="setAttachmentToSplit(attachment)"
        :class="{ active: splittedAttachment && splittedAttachment.url === attachment.url }"
      >
        <VListTileContent class="list-tile">
          <VListTileTitle v-text="attachment.file_name" />
          <VListTileSubTitle style="display: block; white-space: initial">
            <div>{{ attachment.received_mail.from_mail }}</div>
            <div>{{ attachment.received_mail.subject }}</div>
            <div>{{ attachment.created_at | moment('DD.MM.YYYY, HH:mm') }}</div>
          </VListTileSubTitle>
        </VListTileContent>
      </VListTile>
    </VList>
    <div class="invoice-pagination">
      <VBtn
        flat
        icon
        large
        color="primary"
        :disabled="!pagination_splitting.previous"
        @click="getUnprocessedAttachmentList(pagination_splitting.previous)"
      >
        <VIcon>navigate_before</VIcon>
      </VBtn>
      <VBtn
        flat
        color="primary"
        @click="getUnprocessedAttachmentList(pagination_splitting.current)"
      >
        Osveži priponke
      </VBtn>
      <VBtn
        flat
        icon
        large
        color="primary"
        :disabled="!pagination_splitting.next"
        @click="getUnprocessedAttachmentList(pagination_splitting.next)"
      >
        <VIcon>navigate_next</VIcon>
      </VBtn>
    </div>
  </VLayout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'MailAttachmentList',
  computed: {
    ...mapGetters(['attachmentList', 'pagination_splitting', 'splittedAttachment']),
  },
  methods: {
    ...mapActions(['getUnprocessedAttachmentList']),
    setAttachmentToSplit(attachment) {
      this.$store.dispatch('selectAttachment', attachment);
    },
  },
  created() {
    this.getUnprocessedAttachmentList('received-mail-attachments/?limit=8&status=WS');
  },
};
</script>

<style scoped lang="scss">
.list--scroll {
  overflow: scroll;
  padding: 0;
  flex: 1;
}
::-webkit-scrollbar {
  display: none;
}
.list-tile {
  padding: 5px;
  transition: background-color 0.2s ease;
}
::v-deep .v-list--three-line .v-list__tile {
  height: auto;
  min-height: 88px !important;
}
.invoice-pagination {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 56px;
  width: 100%;
  background-color: white;
  border: solid 1px #eeeeee;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.active {
  background: rgba(0, 0, 0, 0.1);
}
.active:hover {
  background: rgba(0, 0, 0, 0.1);
}
</style>
